export function flattenAndSortBusinessSkills( businessSkills, languageCode = 'fr' ) {
    const safeSkills = Array.isArray( businessSkills ) ? businessSkills : [];
    return safeSkills
        .reduce(
            ( acc1, category ) => {
                const competences = Array.isArray( category?.competences )
                    ? category.competences
                    : [];
                const reducedCompetences = competences.map( competence => ( {
                    id: competence.id,
                    translations: competence.translations
                } ) );
                return [
                    ...acc1,
                    ...reducedCompetences
                ];
            }, [] )
        .sort( ( a, b ) => {
            const labelA = a.translations?.[ languageCode ] || '';
            const labelB = b.translations?.[ languageCode ] || '';
            return labelA.localeCompare( labelB );
        } );
}
